import React from 'react';
import BrowseTilesHeader from '../BrowseTiles/BrowseTilesHeader';
import withCountryCode from '../RoutesHoc/RoutesHoc';

const PageNotFoundTitleHeader = ({ buildUrlWithCountry }) => (
  <BrowseTilesHeader title="PAGE NOT FOUND">
    Unfortunately, we can't seem to find the page you're looking for. Click the images below to continue discovering
    italist's luxury fashion offerings, or browse our{' '}
    <a style={{ textDecoration: 'underline' }} href={buildUrlWithCountry()}>
      homepage
    </a>
    .
  </BrowseTilesHeader>
);

export default withCountryCode(PageNotFoundTitleHeader);
